import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-height: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 16px 16px 64px 16px;
  position: relative;
  z-index: 1;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Image = styled.img`
  height: 200px;
  width: 200px;
  border-radius: 50%;
  border: 2px solid #007fff;
  margin-bottom: 48px;
  display: none;

  @media (max-width: 1024px) {
    height: 150px;
    width: 150px;
    display: block;
  }
`;

export const Me = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  padding: 8px;

  p {
    margin: 8px;
    text-align: justify;
    letter-spacing: 1px;
    color: #fff;
  }

  .underlined-a {
    text-decoration: none;
    color: #007fff;
    padding-bottom: 1px;
    box-sizing: border-box;
    box-shadow: inset 0 -2px 0 #007fff;
    transition: 0.2s;

    &:hover {
      color: #fff;
      box-shadow: inset 0 -32px 0 #007fff;
      transition: all 0.4s cubic-bezier(0.9, 0, 0.07, 1);
    }
  }

  ul {
    list-style: disc;
    margin: 16px;
    text-align: justify;
    letter-spacing: 1px;
    color: #fff;
    padding: 8px;
  }

  @media (max-width: 767px) {
    max-width: 375px;

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 16px;
    }
  }
`;

export const Carousel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 50%;
  margin: 32px 0;
  animation: rotate 15s infinite linear;
  transform-style: preserve-3d;

  &:hover {
    animation-play-state: paused;
    cursor: pointer;
  }

  svg {
    filter: grayscale(100%);
    transition: 0.2s;
    opacity: 0.2;
    margin: 8px 16px;
  }

  svg:hover {
    filter: grayscale(0%);
    opacity: 1;
  }

  figure {
    width: auto;
    height: auto;
    overflow: hidden;
    position: absolute;
  }

  figure:nth-child(1) {
    transform: rotateY(0deg) translateZ(300px);
  }
  figure:nth-child(2) {
    transform: rotateY(40deg) translateZ(300px);
  }
  figure:nth-child(3) {
    transform: rotateY(80deg) translateZ(300px);
  }
  figure:nth-child(4) {
    transform: rotateY(120deg) translateZ(300px);
  }
  figure:nth-child(5) {
    transform: rotateY(160deg) translateZ(300px);
  }
  figure:nth-child(6) {
    transform: rotateY(200deg) translateZ(300px);
  }
  figure:nth-child(7) {
    transform: rotateY(240deg) translateZ(300px);
  }
  figure:nth-child(8) {
    transform: rotateY(280deg) translateZ(300px);
  }
  figure:nth-child(9) {
    transform: rotateY(320deg) translateZ(300px);
  }
  figure:nth-child(10) {
    transform: rotateY(360deg) translateZ(300px);
  }

  @keyframes rotate {
    from {
      transform: rotateY(0deg);
    }
    to {
      transform: rotateY(360deg);
    }
  }

  @media (max-width: 767px) {
    figure:nth-child(1) {
      transform: rotateY(0deg) translateZ(150px);
    }
    figure:nth-child(2) {
      transform: rotateY(40deg) translateZ(150px);
    }
    figure:nth-child(3) {
      transform: rotateY(80deg) translateZ(150px);
    }
    figure:nth-child(4) {
      transform: rotateY(120deg) translateZ(150px);
    }
    figure:nth-child(5) {
      transform: rotateY(160deg) translateZ(150px);
    }
    figure:nth-child(6) {
      transform: rotateY(200deg) translateZ(150px);
    }
    figure:nth-child(7) {
      transform: rotateY(240deg) translateZ(150px);
    }
    figure:nth-child(8) {
      transform: rotateY(280deg) translateZ(150px);
    }
    figure:nth-child(9) {
      transform: rotateY(320deg) translateZ(150px);
    }
    figure:nth-child(10) {
      transform: rotateY(360deg) translateZ(150px);
    }

    figure svg {
      height: 30px;
      width: 30px;
    }
  }
`;

export const Undraw = styled.img`
  height: 350px;
  width: 500px;

  @media (max-width: 1024px) {
    display: none;
  }
`;
